import React, { useEffect, useState } from "react"
import _ from "lodash"

import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { DropdownInput, NumberInput } from "components/table/carousel/inputs"
import { field_attrs } from "components/table/lib/column-field"

const ADRBasic = (props: {rowData: [], defaults: object, field: string, persist: Function}) => {
  const [data, setData] = useState<object|null>(props.rowData[props.field]);

  function updateData(val:any, field:string):void {
    let nextData = _.cloneDeep(data)
    if (field === 'inflation.inflationNamedItemId'){
      if (!nextData['inflation']) nextData['inflation'] = {inflationMode: 'namedItem'}
      nextData['inflation']['inflationNamedItemId'] = val
    } else {
      nextData[field] = val
      // if (!nextData['inflation']) nextData['inflation'] = props.defaults['adrInflation']
    }
    setData(nextData);
    props.persist({...nextData, state: 'basic'}, props.field, props.rowData)
  }

  useEffect(() => {
    if (props['rowData']['adrdetail']?.state !== 'basic'){
      setData({inflation: props.defaults['adrInflation']});
    } else if (_.isNil(_.get(data, 'inflation'))) { // for initial creation in basic state
      setData({inflation: props.defaults['adrInflation']});
    }
  }, [props['rowData']])

  const inflationOptions = _.map(
    _.get(props, "namedItems.inflation"),
    item => {
      return {value: item.inflationid, label: item.code}
    }
  )

  const attrs = (field) => field_attrs('room', 'adrdetail')(field)(props.rowData, props)
  const infl_attrs = (field) => field_attrs('room', 'adrdetail')(field, (e) => _(e.path).take(2).isEqual(['adrdetail', 'inflation']))(props.rowData, props)

  return (
    <div>
      <SingleRowCarouselState_s>
        <div>
          <label>ADR</label>
          <NumberInput className="automated" data={data} attrs={attrs} field="amt" readPrecision={4} writePrecision={4} persist={updateData} min={1} max={100000} />
        </div>
        <div>
          <label>Inflation</label>
          <DropdownInput className="automated" data={data} attrs={infl_attrs} field="inflation.inflationNamedItemId" options={inflationOptions} persist={updateData} />
        </div>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default ADRBasic
